/** A URL that addresses one meeting. See `TaskLinkPage` for why these exist. */
import { useNavigate, useParams } from 'react-router'
import { MeetingDrawer } from '../components/MeetingDrawer'
import { MeetingsPage } from './MeetingsPage'

export function MeetingLinkPage() {
  const { meetingId } = useParams<{ meetingId: string }>()
  const navigate = useNavigate()

  if (!meetingId) return null

  const close = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate('/meetings', { replace: true })
  }

  return (
    <>
      <MeetingsPage />
      <MeetingDrawer meetingId={meetingId} onClose={close} />
    </>
  )
}
